var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 92,
    viewBox: "0 0 104 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1066_25147)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.418 31.042C57.7631 31.042 58.043 31.3218 58.043 31.667V33.9587H60.3346C60.6798 33.9587 60.9596 34.2385 60.9596 34.5837C60.9596 34.9288 60.6798 35.2087 60.3346 35.2087H58.043V37.5003C58.043 37.8455 57.7631 38.1253 57.418 38.1253C57.0728 38.1253 56.793 37.8455 56.793 37.5003V35.2087H54.5013C54.1561 35.2087 53.8763 34.9288 53.8763 34.5837C53.8763 34.2385 54.1561 33.9587 54.5013 33.9587H56.793V31.667C56.793 31.3218 57.0728 31.042 57.418 31.042Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0013 31.042L51.9535 31.042C50.0298 31.042 48.5223 31.042 47.3461 31.2001C46.1421 31.362 45.1921 31.6998 44.4464 32.4454C43.7007 33.1911 43.363 34.1411 43.2011 35.3451C43.0429 36.5213 43.043 38.0288 43.043 39.9525V40.0481C43.043 41.9718 43.0429 43.4793 43.2011 44.6556C43.363 45.8595 43.7007 46.8095 44.4464 47.5552C45.1921 48.3009 46.1421 48.6387 47.3461 48.8005C48.5223 48.9587 50.0298 48.9587 51.9535 48.9587H52.0491C53.9728 48.9587 55.4803 48.9587 56.6565 48.8005C57.8605 48.6387 58.8105 48.3009 59.5562 47.5552C60.3019 46.8095 60.6396 45.8595 60.8015 44.6556C60.9597 43.4793 60.9596 41.9718 60.9596 40.0481V40.0003C60.9596 39.6551 60.6798 39.3753 60.3346 39.3753C59.9895 39.3753 59.7096 39.6551 59.7096 40.0003C59.7096 41.9822 59.7083 43.4057 59.5627 44.489C59.5569 44.5317 59.551 44.5738 59.5448 44.6152L57.2331 42.5347C56.1503 41.5601 54.5377 41.4631 53.3458 42.3007L53.0973 42.4754C52.6831 42.7664 52.1197 42.7176 51.7618 42.3597L48.187 38.7849C47.2408 37.8388 45.7231 37.7882 44.7161 38.6694L44.2938 39.0388C44.2976 37.5453 44.319 36.4112 44.4399 35.5116C44.5832 34.4463 44.8556 33.804 45.3303 33.3293C45.805 32.8546 46.4473 32.5822 47.5126 32.439C48.5959 32.2933 50.0194 32.292 52.0013 32.292C52.3465 32.292 52.6263 32.0122 52.6263 31.667C52.6263 31.3218 52.3465 31.042 52.0013 31.042ZM44.4399 44.489C44.5832 45.5543 44.8556 46.1966 45.3303 46.6713C45.805 47.146 46.4473 47.4185 47.5126 47.5617C48.5959 47.7073 50.0194 47.7087 52.0013 47.7087C53.9832 47.7087 55.4067 47.7073 56.49 47.5617C57.5553 47.4185 58.1976 47.146 58.6723 46.6713C58.8752 46.4684 59.0412 46.2348 59.1759 45.9507C59.1435 45.9309 59.1125 45.9078 59.0832 45.8815L56.3969 43.4638C55.7472 42.8791 54.7797 42.8208 54.0645 43.3234L53.816 43.4981C52.9049 44.1384 51.6653 44.031 50.8779 43.2436L47.3031 39.6688C46.8223 39.188 46.051 39.1623 45.5392 39.6101L44.2933 40.7002C44.2954 42.324 44.312 43.5377 44.4399 44.489Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1066_25147",
    x: 0,
    y: 0,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.843137 0 0 0 0 0.886275 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_25147"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1066_25147",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/All.d94e1d7646ce7e501deaa54a25949a06.svg";